export default function InitializeCustomFieldsData(props, form) {
    if (props.formData.custom_fields.length) {
        if (props.formData.custom_fields[0]) {
            form.custom_field_1_data_custom_enabled = props.formData.custom_fields[0]['data_custom_enabled'];
            form.custom_field_1_required = props.formData.custom_fields[0]['required'];
            form.custom_field_1_label = props.formData.custom_fields[0]['label'];
            form.custom_field_1_data = props.formData.custom_fields[0]['data'];
            form.custom_field_1_last_data = props.formData.custom_fields[0]['last_data'];
            form.custom_field_1_value = props.formData.custom_fields[0]['initial_value'];
            form.custom_field_1_custom = '';
        }

        if (props.formData.custom_fields[1]) {
            form.custom_field_2_data_custom_enabled = props.formData.custom_fields[1]['data_custom_enabled'];
            form.custom_field_2_required = props.formData.custom_fields[1]['required'];
            form.custom_field_2_label = props.formData.custom_fields[1]['label'];
            form.custom_field_2_data = props.formData.custom_fields[1]['data'];
            form.custom_field_2_last_data = props.formData.custom_fields[1]['last_data'];
            form.custom_field_2_value = props.formData.custom_fields[1]['initial_value'];
            form.custom_field_2_custom = '';
        }

        if (props.formData.custom_fields[2]) {
            form.custom_field_3_data_custom_enabled = props.formData.custom_fields[2]['data_custom_enabled'];
            form.custom_field_3_required = props.formData.custom_fields[2]['required'];
            form.custom_field_3_label = props.formData.custom_fields[2]['label'];
            form.custom_field_3_data = props.formData.custom_fields[2]['data'];
            form.custom_field_3_last_data = props.formData.custom_fields[2]['last_data'];
            form.custom_field_3_value = props.formData.custom_fields[2]['initial_value'];
            form.custom_field_3_custom = '';
        }

    }
    return form;
}